<template>
  <div class="mb-6" :class="customField.type_id === 2 || customField.type_id === 4 ? 'w-full' : 'w-full md:w-1/3'">
    <div class="md:mr-4">
      <label :for="fieldId" class="block text-sm mb-2">{{ customField.label }}: <span v-if="customField.mandatory" class="text-print-order-teal">*</span></label>
      <!-- Dropdown Select -->
      <select v-if="customField.type_id === 5" v-model="fieldModel.value" :id="fieldId" :name="fieldId" class="w-full border px-2 py-3" :tabindex="tabIndex">
        <option :value="null">[Please Select]</option>
        <option v-for="option in customField.options" :key="option.id" :value="option.id">{{ option.name }}</option>
      </select>
      <!-- Single Checkbox -->
      <checkbox-input v-else-if="customField.type_id === 3" v-model="fieldModel.value" label="Yes" :id="fieldId" :name="fieldId" :tabindex="tabIndex" />
      <!-- Multiple Checkboxes -->
      <div v-else-if="customField.type_id === 4" class="w-full flex flex-wrap">
        <div v-for="(option, i) in customField.options" :key="option.id" class="mr-4">
          <checkbox-input v-model="fieldModel.value[i].value" :label="option.name" :id="fieldId" :name="fieldId" :tabindex="tabIndex" className="mb-2" />
        </div>
      </div>
      <!-- Multi Line Text -->
      <textarea v-else-if="customField.type_id === 2" v-model="fieldModel.value" rows="6" :id="fieldId" :name="fieldId" class="w-full border px-2 py-3" :tabindex="tabIndex"></textarea>
      <!-- Number - Currency -->
      <!-- Number - Formatted -->
      <!-- Single Line Text -->
      <input v-else type="text" v-model="fieldModel.value" :id="fieldId" :name="fieldId" class="input w-full bg-white" :tabindex="tabIndex" />
      <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('custom_field_values.' + count + '.value')" v-text="errorBag.get('custom_field_values.' + count + '.value')"></small>
    </div>
  </div>
</template>
<script>
import { find } from 'lodash'

export default {
  data () {
    return {
    }
  },
  props: ['customField', 'count', 'orderItem', 'errorBag'],
  computed: {
    fieldModel () {
      return find(this.orderItem.custom_field_values, (field) => (field.custom_field_item_id === this.customField.id))
    },
    fieldId () {
      return 'custom-field-' + this.customField.id
    },
    tabIndex () {
      return 100 + this.count
    }
  }
}
</script>
